import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=bf20f254&scoped=true"
import script from "./confirmModal.vue?vue&type=script&lang=js"
export * from "./confirmModal.vue?vue&type=script&lang=js"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=bf20f254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20f254",
  null
  
)

export default component.exports